import { useEffect, useState } from "react";
import { createClient } from "@supabase/supabase-js";
import { createContext, useContext } from "react";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);
const SupabaseContext = createContext(supabase);

export function SupabaseProvider({ children }) {
  return (
    <SupabaseContext.Provider value={supabase}>
      {children}
    </SupabaseContext.Provider>
  );
}

export function useSupabase() {
  return useContext(SupabaseContext);
}

// export function useIsAuthenticated() {
//   const supabase = useSupabase();
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const checkAuth = async () => {
//       const { data } = await supabase.auth.getUser();
//       setIsAuthenticated(!!data?.user);
//       setLoading(false);
//     };
//     checkAuth();

//     const { data: listener } = supabase.auth.onAuthStateChange(
//       (_event, session) => {
//         setIsAuthenticated(!!session?.user);
//         setLoading(false);
//       }
//     );

//     return () => {
//       listener?.subscription?.unsubscribe();
//     };
//   }, [supabase]);

//   return { isAuthenticated, loading };
// }

// export function useSupabaseUser() {
//   const supabase = useSupabase();
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchUser = async () => {
//       const { data } = await supabase.auth.getUser();
//       setUser(data?.user || null);
//       setLoading(false);
//     };
//     fetchUser();

//     const { data: listener } = supabase.auth.onAuthStateChange(
//       (_event, session) => {
//         setUser(session?.user || null);
//         setLoading(false);
//       }
//     );

//     return () => {
//       listener?.subscription?.unsubscribe();
//     };
//   }, [supabase]);

//   return { user, loading };
// }
